import { SET_CONTACT_LIST, SET_CONV_LIST, SET_CURRCHAT_MEMBERS, SET_CURR_CHAT, SET_NEWGROUP_LIST } from "../actions/convListActions";

const initialState = {
    conversationList: [],
    contactList: [],
    newGroupList: [],
    groupMembers: [],
    currChat: {}
};

const convListReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_CURR_CHAT:
            return {
                ...state,
                currChat: action.payload
            };
        case SET_CURRCHAT_MEMBERS:
            return {
                ...state,
                groupMembers: action.payload
            };
        case SET_CONTACT_LIST:
            return {
                ...state,
                contactList: action.payload
            };
        case SET_CONV_LIST:
            return {
                ...state,
                conversationList: action.payload
            };
        case SET_NEWGROUP_LIST:
            return {
                ...state,
                newGroupList: action.payload
            };
        default:
            return state;
    }
};

export default convListReducer;
